import { _request, APIBaseResponse,APIMethod } from '../';

const PROVIDERS_PATH_PREFIX = '/identityproviders';

type APIIdentityProviderGetListResponse = APIBaseResponse<
    Array<{
        id: string;
        name: string;
        issuer: string;
    }>
>;

export const APIIdentityProviderGetList: APIMethod<void, APIIdentityProviderGetListResponse> = () => (
    _request('GET', PROVIDERS_PATH_PREFIX)
);
